/**
 * Assessments Page - ComplyIQ
 *
 * Stub page for managing compliance assessments.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ClipboardCheck, Plus, Search, Filter } from 'lucide-react'

export function AssessmentsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-display font-bold">Assessments</h2>
          <p className="text-muted-foreground">
            Conduct and track compliance assessments and evaluations
          </p>
        </div>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          New Assessment
        </Button>
      </div>

      {/* Filters */}
      <div className="flex gap-4 flex-wrap">
        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="in-progress">In Progress</option>
          <option value="completed">Completed</option>
        </select>

        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search assessments..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-border bg-background text-sm"
          />
        </div>

        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Assessments Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ClipboardCheck className="h-5 w-5" />
            Assessments
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <ClipboardCheck className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-medium">No assessments to display</p>
            <p className="mt-2">
              Assessments will appear here after they are available from ComplyIQ.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
